import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix
import { profile } from 'config/config'; // Importing profile configuration

/**
 * Class representing the FilterAutoexclusionUsersView.
 * @extends JetView
 */
export default class FilterAutoexclusionUsersView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section of the form
        const left = {
            margin: 5,
            rows: [
                {
                    view: 'text', // Text input for ID
                    name: 'Id',
                    label: "<span class='icon-drivers-license-o'></span>" + _('Id'),
                    labelPosition: 'top',
                    placeholder: _('Id'),
                    invalidMessage: _('ID is required'), // Validation message
                },
                {
                    view: 'richselect', // Dropdown for categories
                    name: 'Categorie',
                    localId: 'categorie:combo',
                    label: _("<span class='icon-category'></span> Categorías"),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [], // Options will be populated dynamically
                },
                {
                    view: 'text', // Text input for user creation
                    name: 'UserCreation',
                    label: _("<span class='icon-folder-add'></span> Usuario Creación"),
                    labelPosition: 'top',
                    placeholder: _('Usuario Creación'),
                    invalidMessage: _('Usuario Creación is required'), // Validation message
                },
            ],
        };

        // Center left section of the form
        const center_left = {
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown for subcategories
                    name: 'SubCategory',
                    localId: 'subCategorie:combo',
                    label: _("<span class='icon-subcategory'></span> Sub Categoría"),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [], // Options will be populated dynamically
                },
                {
                    view: 'text', // Text input for user modified
                    name: 'UserModified',
                    label: _("<span class='icon-mode_edit'></span> Usuario Modificó"),
                    labelPosition: 'top',
                    placeholder: _('Usuario Modificó'),
                    invalidMessage: _('Usuario Modificó is required'), // Validation message
                },
            ],
        };

        // Center right section of the form
        const center_right = {
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown for games
                    name: 'Game',
                    localId: 'game:combo',
                    label: _("<span class='icon-games'></span> Juego"),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [], // Options will be populated dynamically
                },
            ],
        };

        // Right section of the form
        const right = {
            margin: 5,
            rows: [
                {
                    view: 'richselect', // Dropdown for activation status
                    name: 'IsActivate',
                    label: _("<span class='icon-state'></span> Estado"),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [
                        { id: 'null', value: 'Todos' },
                        { id: 'A', value: 'Activado' },
                        { id: 'I', value: 'Inactivado' },
                    ],
                },
                {
                    view: 'text', // Text input for datepicker
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true,
                    label: _("<span class='webix_icon icon-calendar'></span> Fecha"),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                },
                {
                    view: 'datepicker', // Datepicker for selecting date
                    name: 'Date',
                    id: 'Date',
                    stringResult: true,
                    minWidth: 200,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                    format: '%d %M %Y',
                    suggest: {
                        type: 'calendar',
                        body: {
                            maxDate: new Date(), // Maximum date is today
                        },
                    },
                },
                {
                    view: 'datepicker', // Duplicate datepicker for selecting date
                    name: 'Date',
                    id: 'Date',
                    stringResult: true,
                    minWidth: 200,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    value: moment().format('YYYY-MM-DD'), // Default value set to today's date
                    format: '%d %M %Y',
                    suggest: {
                        type: 'calendar',
                        body: {
                            maxDate: new Date(), // Maximum date is today
                        },
                    },
                },
            ],
        };

        // Upper section combining all parts
        const upper_section = {
            cols: [
                left,
                { gravity: 0, minWidth: 10 },
                center_left,
                { gravity: 0, minWidth: 10 },
                center_right,
                { gravity: 0, minWidth: 10 },
                right,
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'),
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form fields
                    },
                },
                {
                    view: 'button', // Button to submit the form
                    value: _('Consultar'),
                    hotkey: 'enter', // Enter key to trigger this button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if typeDate is not 2
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if condition is true
                            }
                        }
                        this.app.callEvent('autoexclusionUsers:filter', [filterdata]); // Trigger filter event with data
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets visibility of date fields based on profile settings.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date if typeDate is not 2
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date if typeDate is 2
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });
    }
}

// FILE DOCUMENTED
